// extracted by mini-css-extract-plugin
module.exports = {"container_card":"NoOperationsYet_container_card__2DSjt","btn_add_operation":"NoOperationsYet_btn_add_operation__2FWoC"};